const configHelper = require('../config/index');
import { reduce, replace, isNil, some, startsWith, isEmpty } from 'lodash';

require('../../wwwroot/js/modernizr-custom-mq.js');
const trimTrailingSlash = (virtualdir = '') => {
  return virtualdir.length > 0 && virtualdir[virtualdir.length - 1] === '/'
    ? virtualdir.slice(0, virtualdir.length - 1)
    : virtualdir;
};
const getSiteUrl = (virtualdir = window.$pathBase) => {
  if (virtualdir === undefined) {
    throw new Error(
      'common.getSiteUrl: virtualdir undefined. Should be emtpy or set.',
    );
  }
  if (window.location.port === '') {
    return trimTrailingSlash(
      window.location.protocol + '//' + window.location.hostname + virtualdir,
    );
  }
  return trimTrailingSlash(
    window.location.protocol +
      '//' +
      window.location.hostname +
      ':' +
      window.location.port +
      virtualdir,
  );
};
const getSiteCommercialName = () => {
  const siteName = {
    lordgun: 'LordGun',
    runkd: 'RUNKD',
    inwild: 'INWILD',
  };
  return siteName[SITE.toLowerCase()];
};
const contentFromCdn = ({ path, keepUrlAsIs }) => {
  try {
    if (keepUrlAsIs === true) {
      return path;
    }
    const config = configHelper.getConfig();
    const { useCdn, cdnImagesUrl, cdnImagesFallbackUrl, cms } = config;

    if (cms && cms.cmsUrl && !isNil(cms.cmsUrl) && !isEmpty(cms.cmsUrl)) {
      if (startsWith(path, cms.cmsUrl)) {
        return path;
      }
    }

    if (some([useCdn, cdnImagesUrl, cdnImagesFallbackUrl], isNil)) {
      throw new Error('Some config for contentFromCdn is missing');
    }
    let transformedPath = replace(path.toLowerCase(), '~', '');
    transformedPath = replace(
      transformedPath,
      '/content/products',
      '/products',
    );
    transformedPath = replace(transformedPath, '/content/kits', '/kits');
    transformedPath = replace(transformedPath, '/content/img/', '/img/');
    transformedPath = replace(transformedPath, '/content/img', '/img');
    transformedPath = replace(transformedPath, 'content/img/', '/img/');
    transformedPath = replace(transformedPath, 'content/', '');
    transformedPath = replace(transformedPath, cdnImagesUrl, '');
    transformedPath = replace(transformedPath, cdnImagesFallbackUrl, '');
    let siteUrl = getSiteUrl().toLowerCase();
    transformedPath = transformedPath.replace(siteUrl, '');
    transformedPath = replace(
      transformedPath,
      window.$pathBase.toLowerCase(),
      '',
    );
    transformedPath = transformedPath.startsWith('/')
      ? transformedPath.slice(1, transformedPath.length)
      : transformedPath;
    if (useCdn && startsWith(transformedPath, cdnImagesUrl.toLowerCase())) {
      transformedPath = replace(
        transformedPath,
        cdnImagesUrl.toLowerCase(),
        '',
      );
    }
    if (
      useCdn === false &&
      startsWith(transformedPath, cdnImagesFallbackUrl.toLowerCase())
    ) {
      transformedPath = replace(
        transformedPath,
        cdnImagesFallbackUrl.toLowerCase(),
        '',
      );
    }

    let finalPath = useCdn
      ? `${cdnImagesUrl}/${transformedPath}`
      : `${cdnImagesFallbackUrl}/${transformedPath}`;
    return finalPath;
  } catch (error) {
    console.error('contentFromCdn. Set content from Cdn', error);
  }
};
const getPartnersByCulture = ({ culture, partners }) => {
  const items = reduce(
    partners,
    (acc, el) => {
      return el.Culture === culture ? acc.concat(el) : acc;
    },
    [],
  );
  return reduce(
    items,
    (acc, p) => {
      acc.push({
        title: p.Name,
        url: p.Url,
        culture: p.Culture,
        logo: contentFromCdn({
          path: `/Content/img/${p.Logo}`,
          keepUrlAsIs: false,
        }),
      });
      return acc;
    },
    [],
  );
};
const getParameterByName = function (name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
export default {
  getSiteUrl,
  getLang: () => document.documentElement.lang,
  isTouch: () => Modernizr.touch || window.innerWidth <= 768,
  isDesktop: () => Modernizr.mq('(min-width: 64em)'),
  getSite: () => SITE.trim().toLowerCase(),
  getSiteCommercialName,
  contentFromCdn,
  getPartnersByCulture,
  getParameterByName,
};
